<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDtmf_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M9.6 13.929C9.6 14.52 9.108 15 8.5 15s-1.1-.48-1.1-1.071c0-.592.492-1.072 1.1-1.072s1.1.48 1.1 1.072M9.6 9.643c0 .592-.492 1.071-1.1 1.071s-1.1-.48-1.1-1.071c0-.592.492-1.072 1.1-1.072s1.1.48 1.1 1.072M9.6 5.357c0 .592-.492 1.072-1.1 1.072s-1.1-.48-1.1-1.072.492-1.071 1.1-1.071 1.1.48 1.1 1.071"
    />
    <path
        fill="currentColor"
        d="M9.6 1.071c0 .592-.492 1.072-1.1 1.072s-1.1-.48-1.1-1.072C7.4.48 7.892 0 8.5 0s1.1.48 1.1 1.071"
    />
    <path
        fill="currentColor"
        d="M14 9.643c0 .592-.492 1.071-1.1 1.071-.607 0-1.1-.48-1.1-1.071 0-.592.492-1.072 1.1-1.072.607 0 1.1.48 1.1 1.072M14 5.357c0 .592-.492 1.072-1.1 1.072-.607 0-1.1-.48-1.1-1.072s.492-1.071 1.1-1.071c.607 0 1.1.48 1.1 1.071M14 1.071c0 .592-.492 1.072-1.1 1.072-.607 0-1.1-.48-1.1-1.072C11.8.48 12.292 0 12.9 0c.607 0 1.1.48 1.1 1.071M5.2 9.643c0 .592-.492 1.071-1.1 1.071S3 10.234 3 9.643c0-.592.492-1.072 1.1-1.072s1.1.48 1.1 1.072M5.2 5.357c0 .592-.492 1.072-1.1 1.072S3 5.949 3 5.357s.492-1.071 1.1-1.071 1.1.48 1.1 1.071M5.2 1.071c0 .592-.492 1.072-1.1 1.072S3 1.663 3 1.07C3 .48 3.492 0 4.1 0s1.1.48 1.1 1.071"
    />
</svg>
